export const  GET_LIBRARY_REQUEST='libraryReducer/GET_LIBRARY_REQUEST';
export const  GET_LIBRARY_SUCCESS='libraryReducer/GET_LIBRARY_SUCCESS';
export const  GET_LIBRARY_FAILED='libraryReducer/GET_LIBRARY_FAILED';